import React from "react";
import { Box } from "@mui/material";
import { NavLink, Outlet } from "react-router-dom";

const navLinks = [
  { name: "Коли", page: "cars" },
  { name: "Потребители", page: "drivers" },
  { name: "Дневен отчет", page: "day" },
  { name: "Седмичен отчет", page: "week" },
  { name: "Месечен отчет", page: "month" },
];

const Admin = () => {
  return (
    <Box sx={{ marginBottom: "50px" }}>
      <Box
        sx={{
          marginBottom: "50px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: {
            xs: "column",
            lg: "row",
          },
          padding: {
            xs: 0,
            lg: "30px",
          },
        }}
      >
        {" "}
        {navLinks.map((link) => (
          <NavLink
            key={link.page}
            to={link.page}
            style={({ isActive }) => ({
              color: isActive ? "blue" : "black",
              borderBottom: isActive ? "1px solid blue" : "none",
            })}
          >
            {link.name}
          </NavLink>
        ))}
      </Box>
      <Outlet />
    </Box>
  );
};

export default Admin;
